import type { Command } from '@blocksuite/std';
import type { BlockModel } from '@blocksuite/store';

import { containsDatabaseBlock } from '../../adapters/middlewares/database-clipboard';
import { deleteSelectedModelsCommand } from './delete-selected-models';

/**
 * Deletes what a cut takes out of the document. A database, and any block
 * that holds one, stays in place: only the paste moves it out of its document.
 */
export const deleteCutModelsCommand: Command<
  { selectedModels?: BlockModel[] },
  { keptModels: BlockModel[] }
> = (ctx, next) => {
  const keptModels: BlockModel[] = [];
  const selectedModels: BlockModel[] = [];
  for (const model of ctx.selectedModels ?? [])
    (containsDatabaseBlock(model) ? keptModels : selectedModels).push(model);
  if (selectedModels.length > 0)
    ctx.std.command.exec(deleteSelectedModelsCommand, {
      selectedModels,
      deleteOptions: { moving: true },
    });
  return next({ keptModels });
};
